'use client';

import type { ReactNode } from 'react';
import { useBreakpoint } from '@/shared/hooks/use-media-query';
import { DesktopShell } from '@/shared/ui';
import { AppSidebar } from './AppSidebar';

interface DashboardDesktopLayoutProps {
  children: ReactNode;
}

/**
 * Desktop layout wrapper for the Dashboard page.
 *
 * Breakpoint behavior:
 * - < lg (1024px): Mobile layout, renders children directly
 * - >= lg (1024px): 2-column layout (sidebar + content)
 */
export function DashboardDesktopLayout({
  children,
}: DashboardDesktopLayoutProps) {
  const { isLg } = useBreakpoint();

  if (!isLg) {
    return <>{children}</>;
  }

  return (
    <DesktopShell sidebar={<AppSidebar />}>
      <main className="flex-1 min-w-0 overflow-y-auto">
        {children}
      </main>
    </DesktopShell>
  );
}
